// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1Xz64","footer":"ModalError_footer__39n25"};